import React from 'react';
import { CellText } from '@opendate-app/setlist';
import ReportingGiftCardsReportPage, { formatCents, centsKpiCard, countKpiCard } from './ReportingGiftCardsReportPage';
import {
  GIFT_CARD_REDEMPTIONS_COLUMNS, SORT_TYPES, defaultVisibleColumns, defaultHiddenColumns,
} from '../constants/giftCardsColumnsConfig';

const REDEMPTIONS_CONFIG = {
  pageTitle: 'Gift Card Redemptions',
  pageSubtitle: 'How much of your gift cards was used in the selected range, by venue and event. Gift card money refunded from a ticket order is netted out, whether it went back onto the card or to the person who bought the card.',
  sidebarKey: 'gift_cards_redemptions',
  defaultPreset: 'year_to_date',
  dateModeOptions: [{ key: 'order_date', label: 'Used Date' }],
  defaultSortRules: [{ field: 'net_cents', direction: 'desc' }],

  columns: GIFT_CARD_REDEMPTIONS_COLUMNS,
  sortTypes: SORT_TYPES,
  getDefaultVisibleColumns: defaultVisibleColumns(GIFT_CARD_REDEMPTIONS_COLUMNS),
  getDefaultHiddenColumns: defaultHiddenColumns(GIFT_CARD_REDEMPTIONS_COLUMNS),
  localStorageKey: (teamId) => `reportingGiftCardsRedemptionsColumns_${teamId}`,
  firstColumnId: 'venue_name',

  detailErrorMessage: 'Failed to load gift card redemptions.',
  detailTableTitle: 'Redemptions by Venue and Event',
  emptyMessage: 'No gift cards were used in this range.',
  searchPlaceholder: 'Search venues and events...',

  buildKpiCards: (current, prior) => [
    centsKpiCard('Net Used', 'net_cents', current, prior),
    countKpiCard('Uses', 'uses', current, prior),
    centsKpiCard('Redeemed', 'redeemed_cents', current, prior),
    centsKpiCard('Refunded', 'refunded_cents', current, prior),
  ],

  renderCellValue: (col, row, { formatEventDate }) => {
    switch (col.id) {
      case 'venue_name': return row.venue_name || '—';
      case 'event_name': return row.event_name || '—';
      case 'event_date': return row.event_date ? formatEventDate(row.event_date) : '—';
      case 'uses': return (row.uses || 0).toLocaleString();
      case 'net_cents': return <CellText primary={formatCents(row.net_cents)} />;
      default: return formatCents(row[col.id]);
    }
  },
};

function ReportingGiftCardsRedemptionsPage(props) {
  return (
    <ReportingGiftCardsReportPage
      {...props}
      report="redemptions"
      filterIds={['gift_card_product_id', 'venue_ownership_id']}
      config={REDEMPTIONS_CONFIG}
    />
  );
}

export default ReportingGiftCardsRedemptionsPage;
